// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  width: 350px;
  max-height: 500px;
  background: #1a1a1a;
  border: 1px solid #333;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  z-index: 1000;
  animation: slideDown 0.3s ease-out;
  margin-top: 8px;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.notification-dropdown-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #333;
  background: #2a2a2a;
  border-radius: 8px 8px 0 0;
}

.notification-dropdown-header h3 {
  margin: 0;
  color: #00ff00;
  font-size: 16px;
  font-weight: 600;
}

.mark-all-read-btn {
  background: none;
  border: 1px solid #00ff00;
  color: #00ff00;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.mark-all-read-btn:hover {
  background: #00ff00;
  color: #1a1a1a;
}

.notification-dropdown-content {
  max-height: 400px;
  overflow-y: auto;
}

.notification-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #888;
}

.notification-loading-spinner {
  width: 24px;
  height: 24px;
  border: 2px solid #333;
  border-top: 2px solid #00ff00;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 12px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.notification-empty,
.notification-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
  color: #888;
}

.empty-icon,
.error-icon {
  font-size: 24px;
  margin-bottom: 12px;
  opacity: 0.7;
  font-weight: bold;
}

.empty-icon {
  color: #00ff00;
}

.error-icon {
  color: #ff6b6b;
  background: #ff6b6b;
  color: white;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.notification-empty p,
.notification-error p {
  margin: 0 0 8px 0;
  font-size: 16px;
  color: #ccc;
}

.notification-error p {
  color: #ff6b6b;
}

.notification-empty span,
.notification-error span {
  font-size: 14px;
  color: #888;
}

.notification-list {
  padding: 0;
}

.notification-dropdown-footer {
  padding: 12px 20px;
  border-top: 1px solid #333;
  background: #2a2a2a;
  border-radius: 0 0 8px 8px;
  text-align: center;
}

.view-all-link {
  color: #00ff00;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  transition: color 0.2s ease;
}

.view-all-link:hover {
  color: #00cc00;
  text-decoration: underline;
}

/* Responsive design */
@media (max-width: 768px) {
  .notification-dropdown {
    width: 300px;
    right: -50px;
  }
}

@media (max-width: 480px) {
  .notification-dropdown {
    width: 280px;
    right: -30px;
  }
  
  .notification-dropdown-header {
    padding: 12px 16px;
  }
  
  .notification-dropdown-header h3 {
    font-size: 14px;
  }
  
  .mark-all-read-btn {
    padding: 3px 8px;
    font-size: 11px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/notifications/NotificationDropdown.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;IACZ,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF","sourcesContent":[".notification-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  width: 350px;\n  max-height: 500px;\n  background: #1a1a1a;\n  border: 1px solid #333;\n  border-radius: 8px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);\n  z-index: 1000;\n  animation: slideDown 0.3s ease-out;\n  margin-top: 8px;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.notification-dropdown-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  border-bottom: 1px solid #333;\n  background: #2a2a2a;\n  border-radius: 8px 8px 0 0;\n}\n\n.notification-dropdown-header h3 {\n  margin: 0;\n  color: #00ff00;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.mark-all-read-btn {\n  background: none;\n  border: 1px solid #00ff00;\n  color: #00ff00;\n  padding: 4px 12px;\n  border-radius: 4px;\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.mark-all-read-btn:hover {\n  background: #00ff00;\n  color: #1a1a1a;\n}\n\n.notification-dropdown-content {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.notification-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px;\n  color: #888;\n}\n\n.notification-loading-spinner {\n  width: 24px;\n  height: 24px;\n  border: 2px solid #333;\n  border-top: 2px solid #00ff00;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 12px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.notification-empty,\n.notification-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px;\n  text-align: center;\n  color: #888;\n}\n\n.empty-icon,\n.error-icon {\n  font-size: 24px;\n  margin-bottom: 12px;\n  opacity: 0.7;\n  font-weight: bold;\n}\n\n.empty-icon {\n  color: #00ff00;\n}\n\n.error-icon {\n  color: #ff6b6b;\n  background: #ff6b6b;\n  color: white;\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n}\n\n.notification-empty p,\n.notification-error p {\n  margin: 0 0 8px 0;\n  font-size: 16px;\n  color: #ccc;\n}\n\n.notification-error p {\n  color: #ff6b6b;\n}\n\n.notification-empty span,\n.notification-error span {\n  font-size: 14px;\n  color: #888;\n}\n\n.notification-list {\n  padding: 0;\n}\n\n.notification-dropdown-footer {\n  padding: 12px 20px;\n  border-top: 1px solid #333;\n  background: #2a2a2a;\n  border-radius: 0 0 8px 8px;\n  text-align: center;\n}\n\n.view-all-link {\n  color: #00ff00;\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 500;\n  transition: color 0.2s ease;\n}\n\n.view-all-link:hover {\n  color: #00cc00;\n  text-decoration: underline;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .notification-dropdown {\n    width: 300px;\n    right: -50px;\n  }\n}\n\n@media (max-width: 480px) {\n  .notification-dropdown {\n    width: 280px;\n    right: -30px;\n  }\n  \n  .notification-dropdown-header {\n    padding: 12px 16px;\n  }\n  \n  .notification-dropdown-header h3 {\n    font-size: 14px;\n  }\n  \n  .mark-all-read-btn {\n    padding: 3px 8px;\n    font-size: 11px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
